/** Wraps ServiceLad pages in the Cloud White shell. Other brands pass through. */
export default function SlCloudShell({ brand, children }) {
  if (brand?.key !== "servicelad") return children;
  return (
    <div className="sl-cloud relative min-h-screen bg-background text-foreground font-body">
      <div className="atmosphere" aria-hidden />
      <div className="relative z-10">{children}</div>
    </div>
  );
}
